<template>
  <div>
    <div class="grid grid-cols-3 font-heiti text-sm pt-1">
      <div class="col-span-1">线上文审：<img class="inline h-6" ref="seven" alt="" v-for="(_, i) in info.strSeven" src="" :key="i" /></div>
      <div class="col-span-2">现场评测组：<img class="inline h-6" alt="" ref="right" v-for="(_, i) in info.strRight" src="" :key="i" /></div>
      <div class="col-span-1">质检校核：<img class="inline h-6" alt="" ref="nine" v-for="(_, i) in info.strNine" src="" :key="i" /></div>
      <div class="col-span-1">报告日期：{{info.reportDate}}</div>
      <div class="col-span-1 text-right">第 {{page}} 页（共 {{total}} 页）</div>
    </div>
  </div>
</template>

<script>
// 页脚
import { getFile } from '@/api/enterprise'

export default {
  props: ['info', 'page', 'total'],
  mounted () {
    this.loadImages()
  },
  methods: {
    loadImages () {
      this.info.strSeven.forEach((id, i) => {
        this.getAvatar(this.info.e.find(v => v.id === id)?.avatar).then(url => {
          this.$refs.seven[i].src = url
        })
      })
      this.info.strRight.forEach((id, i) => {
        this.getAvatar(this.info.e.find(v => v.id === id)?.avatar).then(url => {
          this.$refs.right[i].src = url
        })
      })
      this.info.strNine.forEach((id, i) => {
        this.getAvatar(this.info.e.find(v => v.id === id)?.avatar).then(url => {
          this.$refs.nine[i].src = url
        })
      })
    },
    async getAvatar (id) {
      try {
        const res = await getFile(id)
        return URL.createObjectURL(res.data)
      } catch (error) {
        console.error('image load fail')
      }
    }
  }
}
</script>
